<template>
  <div>
    <v-row class="mt-0 px-1" v-if="loadingKanban">
      <v-col cols="12" sm="3" md="3" lg="3" v-for="i in 4" :key="i">
        <v-card v-for="rand in randomNumber(4)" :key="rand">
          <v-skeleton-loader type="list-item-three-line" class="mb-3"></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-0 px-1" v-if="!loadingKanban && !!kanban && kanban.etapas && kanban.etapas.length">
      <v-col v-for="(item, index) in kanban.etapas" :key="index">
        <div :style="'background-color: ' + item.fet_cor" class="text-center text-h2 py-3 titulo_kanban">
         <b>
            {{item.fet_nome}}
         </b>
        </div>
        <draggable class="list-group" :id="item.uuid_fet_id" :list="item.oportunidades" group="kanban" @end="checkMove" :style="'border-color: ' + item.fet_cor">
          <div class="list-group-item" v-for="(subitem, subindex) in item.oportunidades" :key="subindex" :class="$vuetify.theme.dark ? 'item-dark' : 'item-white'">
            <v-row align="center" no-gutters justify="space-between" class="subitem-info">
              <span class="caption subitem-link" @click="goToOportunidade(subitem.uuid_opu_id)">Cod. {{ subitem.opu_id }}</span>
              <span class="caption te">Criado há: {{ retornaTempoAbertura(subitem.opu_criado_em) }}</span>
            </v-row>
            <div class="w-100">
              <div class="text text--thin mb-1 subitem-link" @click="goToContact(subitem.cliente.uuid_cli_id)">
                {{subitem.cliente.cli_nome}}
              </div>
              <div class="caption mb-1">
                {{subitem.opu_observacao}}
              </div>
              <div class="text-h3">
                {{subitem.pos_total ? $root.Formatter.floatToMoney(subitem.pos_total) : 'R$ 0,00'}}
                <span class="caption">Valor médio</span>
              </div>
            </div>
          </div>
        </draggable>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import draggable from 'vuedraggable'

export default {
  props: ['status'],
  components: {
    draggable
  },
  data () {
    return {
      funis: [],
      funil: null,
      loading: false,
      loadingKanban: false,
      kanban: [],
      tipos: ['Sistema fotovoltaico']
    }
  },
  methods: {
    goToOportunidade (uuid) {
      this.$router.push({ name: 'OportunidadeInterna', params: { uuid } }).catch(() => {})
    },
    goToContact (uuid) {
      this.$router.push({ name: 'Contato', params: { uuid } }).catch(() => {})
    },
    randomNumber (ate) {
      return Math.floor(Math.random() * ate) + 1
    },
    retornaTempoAbertura (dataCriacao) {
      const hoje = moment()
      const criacao = moment(dataCriacao)
      const diasAbertos = hoje.diff(criacao, 'days')
      return diasAbertos > 1 ? `${diasAbertos} dias` : `${diasAbertos} dia`
    },
    checkMove (evt) {
      let dados = [{
        uuid_fun_id: this.funil,
        uuid_fet_id: evt.to.id,
        uuid_opu_id: evt.item._underlying_vm_.uuid_opu_id
      }]
      this.alteraEtapa(dados)
    },
    async alteraEtapa (novaEtapa) {
      const etapas = {etapas: novaEtapa}
      const { status } = await Api.post('oportunidades/altera/etapas', etapas)
      if (status !== 200) {
        console.log(status, 'status')
        this.$root.SnackControl.open(this, {
          text: 'Ops, ocorreu um erro ao alterar a etapa desta oportunidade!',
          color: 'error'
        })
      }
    },
    async getFunis () {
      this.loading = true
      await Api.get('funis')
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.funis = res.data
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os funis!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getKanban () {
      if (this.funis.length === 0) return

      this.loadingKanban = true

      this.funil = this.funis[0].uuid_fun_id
      if (this.status === 3) {
        this.funil = this.funis[1].uuid_fun_id
      }

      const endpoint = `oportunidades/kanban/${this.funil}?status=${this.status}`
      await Api.get(endpoint)
        .then(res => {
          if (res.data) {
            this.kanban = res.data
          }
          this.loadingKanban = false
        })
        .catch(err => {
          this.loadingKanban = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async loadFunctions () {
      await this.getFunis()
      await this.getKanban()
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.list-group {
  border: 1px solid;
  border-radius: 0px;
  padding: 10px;
  min-height: 480px;
}
.list-group-item {
  border-radius: 0px;
  cursor: move;
  margin-bottom: 5px;
  overflow: hidden;
  padding: 10px;
  padding-top: 1.6em;
  position: relative;
  &:nth-last-of-type(1) {
    margin-bottom: 0px;
  }
}
.item-dark {
  background: #121212;
}
.item-white {
  background: #d7d7d7;
}
.subitem {
  &-info {
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    span {
      background-color: #333333;
      color: #fff;
      padding: 0px 10px;
    }
  }
  &-link {
    cursor: pointer;
    transition: 0.3s ease;
    &:hover {
      color: $primary;
      transition: 0.3s ease;
    }
  }
}
.titulo_kanban {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 21px!important;
  justify-content: center;
  min-height: 96px;
  padding-left: 2px;
  padding-right: 2px;
  @media (max-width: 1200px){
    font-size: 19px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/oportunidades/KanbanOportunidades.vue